import { createContext } from 'react';

import { defaultLegend } from '../constants.js';
import { TimeseriesChartLegendConfig } from '../types/timeseries-config.js';

export const TimeseriesLegendContext =
  createContext<TimeseriesChartLegendConfig>(defaultLegend);

TimeseriesLegendContext['displayName'] = 'TimeseriesLegendContext';
